import { type ColumnDefinition, ModelColumns } from '~/types/components';
import type { SourceEmail } from '~/types/models';

export const Columns: Array<ColumnDefinition<SourceEmail>> = [
  {
    title: 'Courriel',
    key: 'email',
    sortable: true,
    type: 'string',
  },
  {
    title: 'Nom',
    key: 'name',
    sortable: true,
    type: 'string',
  },
  ...ModelColumns,
];
